





























































import Vue from "vue";
import { VDataTable } from "vuetify/lib";
import { PropValidator } from "vue/types/options";
import { DataTableHeader } from "vuetify";

interface CustomDataTableHeader extends DataTableHeader {
  pipe: () => any;
}

export default Vue.extend({
  name: "base-data-table",
  mixins: [VDataTable],
  props: {
    title: {
      type: String,
      required: false,
    },
    buttons: {
      type: Array as () => {
        label: string;
        color: string;
        action: () => {};
        disabled: boolean | (() => boolean);
      }[],
      required: false,
    },
    headers: {
      type: Array,
      default: () => [],
    } as PropValidator<CustomDataTableHeader[]>,
    actions: {
      type: Array as () => {
        icon: string;
        color: string;
        action: (item?: any) => {};
        disabled: boolean | ((item?: any) => boolean);
      }[],
      required: false,
    },
  },
  computed: {
    computedProps(): Record<string, any> {
      const props = { ...this.$props };
      const test = [];
      if (this.actions && !props.headers.find((header: CustomDataTableHeader) => header.value == "actions")) {
        console.log(props);
        props.headers.push({
          text: this.$tc("actions"),
          sortable: false,
          value: "actions",
        });
      }
      return props;
    },

  },
});
